import type { SVGProps } from "react";
// generated from ChevronUp.svg — do not edit manually
// prettier-ignore
export default function ChevronUp(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 6 15 L 12 9 L 18 15" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
